module.exports = __webpack_public_path__ + "static/img/behaviour-notdata.33b7f5cd.png";